const features = {
  test: 'test',
  theShop: 'theShop',
  candleSubscription: 'candleSubscription',
  fragranceFamiliesPage: 'fragranceFamiliesPage',
  noteLibPages: 'noteLibPages',
  addQuebecToCanada: 'addQuebecToCanada',
  recurlyKountDDC: 'recurlyKountDDC', // EP-1113
  privateSale: 'privateSale', // EP-730
  twoThreePerfumesPopup: 'twoThreePerfumesPopup',
  wallet: 'wallet',
  defaultCoupon50: 'defaultCoupon50', // PF-892
  hideCancelSubscriptionButton: 'hideCancelSubscriptionButton', // EP-1424
  additionalResubscribePopup: 'additionalResubscribePopup', // EP-1450
  jasonWuGwp: 'JasonWuGwp', // SB-2811
  cashbirdSubscriptionSettings: 'cashbirdSubscriptionSettings', // PF-1155
  mothersDay: 'mothersDay', // EP-1571
  fathersDay: 'fathersDay', // EP-1646
  julySale: 'julySale', // EP-1731
  newLastShipmentReviewLogic: 'newLastShipmentReviewLogic', // SB-3795
  scentPreferences: 'scentPreferences', // EP-1630
  serviceWorker: 'serviceWorker', // EP-1603
  loqateAutocomplete: 'loqateAutocomplete', // PF-1152
  giftSetsPage: 'giftSetsPage',
  multipleMerchantsForAmazonPay: 'multipleMerchantsForAmazonPay', // EP-1369
  fragranceCatalogStickyFooter: 'fragranceCatalogStickyFooter', // EP-1446,
  mobileAppPopup: 'mobileAppPopup', // PF-545, PF-1277
  theEdit: 'theEdit', // PF-1242
  ecommercePrefix: 'ecommercePrefix', // PF-1352
  featuredBrand: 'featuredBrand', // PF-408
  candleClubMoreBanners: 'candleClubMoreBanners', // CRO-26
  websiteTakeoverHarmonist: 'websiteTakeoverHarmonist', // PF-1337
  partytown: 'partytown', // PF-1185
  techCartContinueBar: 'techCartContinueBar', // CRO-72
  collaborationSaks: 'collaborationSaks', // PF-1389
  giftCardFraud: 'giftCardFraud', // EP-1846
  optInPopups: 'optInPopups', // PF-1279
  freeShippingProgressBar: 'freeShippingProgressBar', // EP-1845
  websiteTakeoverDOS: 'websiteTakeoverDOS', // PF-1436
  caseSubPromoPopup: 'caseSubPromoPopup', // EP-1839
  magicLinkWeb: 'magicLinkWeb', // EP-1869
  popupsLoader: 'popupsLoader',
  strapiBanners: 'strapiBanners', // PF-1464
} as const


export type FeatureName = typeof features[keyof typeof features]

export default features
